import { logger } from '@/utils/logger.ts';

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        dataHandler: {
          postMessage(parameter: string): string;
        };
      };
    };
    Android?: {
      // AOS 인터페이스
      dataHandler(parameter: string): string;
    };
  }
}

interface BridgeParameter<T = any> {
  type: string;
  data?: T;
}

export const landingYoutube = (
  videoId: string,
  index: string,
  page?: string,
) => {
  logger.debug('landingYoutube', videoId);
  index = page ? `${page}_${index}` : index;
  const key = page ? 'AI검색_지난대화' : 'AI검색_최근대화';
  logger.debug(key);
  logger.debug(index);
  sendEvent('SEND_LOG', {
    type: 'GA4',
    key: key,
    message: index,
  });
  const url = `https://www.youtube.com/shorts/${videoId}`;
  sendEvent('LANDING_YOUTUBE', { url: url });
};

export const launchYoutube = (
  videoId: string,
  title: string,
  index: string,
  count: number,
) => {
  const url = `https://www.youtube.com/shorts/${videoId}`;
  sendEvent('LAUNCH_YOUTUBE', {
    url,
    id: videoId,
    title,
    index,
    count,
  });
};

/**
 * @param type - 0 : 아이콘 없음, 1 : 느낌표 아이콘, 2 : 체크 아이콘
 * @praam
 */
export const popupToast = (type: number, message: string) => {
  sendEvent('POPUP_TOAST', {
    type: type,
    message: message,
  });
  logger.debug('sendEvent call :: POPUP_TOAST');
};

export const hasNativeBridge = () =>
  window.webkit?.messageHandlers?.dataHandler || window.Android?.dataHandler;

const sendEventToIOS = (key: string, param?: any) => {
  const parameter: BridgeParameter = {
    type: key,
    ...(param && { data: param }),
  };

  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.dataHandler
  ) {
    const stringifiedObject = JSON.stringify(parameter);
    window.webkit.messageHandlers.dataHandler.postMessage(stringifiedObject);
    logger.debug(`iOS Bridge called : ${stringifiedObject}`);
  } else {
    logger.debug(`iOS Bridge is not ready. [${key}]`);
  }
};

const sendEventToAOS = (key: string, param?: any) => {
  const parameter: BridgeParameter = {
    type: key,
    ...(param && { data: param }),
  };
  if (window.Android) {
    const stringifiedObject = JSON.stringify(parameter);
    window.Android.dataHandler(stringifiedObject);
    logger.debug(`AOS Bridge called : ${stringifiedObject}`);
  } else {
    logger.debug('AOS Bridge is not ready');
  }
};

function initSendEventFn() {
  if (window.webkit) {
    return sendEventToIOS;
  } else if (window.Android) {
    return sendEventToAOS;
  } else {
    return () => {
      logger.debug('is not a webview');
    };
  }
}

const sendEventFn = initSendEventFn();

export const sendEvent = async (key: string, param?: any) =>
  sendEventFn(key, param);
